<template>
  <div class="box7">
    <img class="bg" src="../../../assets/coursePage/stevens/box7/bg.png" alt="">
  </div>
</template>

<script>
export default {
  components: {

  },
  data() {
    return {
      
    };
  },

  methods: {},
};
</script>

<style  lang="less" scoped>
.box7 {
  background: #fff;
  width: 100%;
  height: 706px;
  .bg {
    width: 100%;
    height: 706px;
    display: block;
  }
}
</style>
